import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from '../../../services/common.service';

@Component({
  selector: 'start-tour',
  templateUrl: './start-tour.component.html',
  styleUrls: ['./start-tour.component.scss']
})
export class StartTourComponent implements OnInit {

  loading: any = false;

  constructor(public dialogRef: MatDialogRef<StartTourComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
  }

  onNoClick(val: boolean): void {
    if (!val) {
      val= false;
    }
    this.dialogRef.close({data : val });
  }

  takeTour() {
    this.data;
    this.data.takeTour = true;
    this.onNoClick(this.data.takeTour);
  }

  doNotShow(event) {
    this.loading = true;
    this.commonService.updateDoNotShowTour().subscribe((res: any) => { 
      if (res.status == true) {
        this.onNoClick(false);
        sessionStorage.setItem("doNotShowTour", "1");
      }
    });
  }
}
